import { Command } from "./Command";
import { MeshRenderer } from "../../../core/MeshRenderer";
import { Laya3DRender } from "../../../RenderObjs/Laya3DRender";
import { RenderContext3D } from "../RenderContext3D";
import { Pool } from "../../../../utils/Pool";
import { Stat } from "../../../../utils/Stat";
import { LayaGL } from "../../../../layagl/LayaGL";
export class DrawMeshCMD extends Command {
    static create(mesh, matrix, material, subMeshIndex, subShaderIndex, commandBuffer) {
        var cmd;
        cmd = DrawMeshCMD._pool.take();
        cmd._matrix = matrix;
        cmd._transform.worldMatrix = cmd._matrix;
        cmd.material = material;
        cmd.subMeshIndex = subMeshIndex;
        cmd._subShaderIndex = subShaderIndex;
        cmd.mesh = mesh;
        cmd._commandBuffer = commandBuffer;
        return cmd;
    }
    get subMeshIndex() {
        return this._subMeshIndex;
    }
    set subMeshIndex(value) {
        this._subMeshIndex = value;
        this._drawRenderCMDDData.subMeshIndex = value;
    }
    constructor() {
        super();
        this._drawRenderCMDDData = Laya3DRender.Render3DPassFactory.createDrawNodeCMDData();
        this._transform = Laya3DRender.Render3DModuleDataFactory.createTransform(null);
        this._meshRender = new MeshRenderer();
    }
    set material(value) {
        this._material && this._material._removeReference(1);
        this._material = value;
        this._material && this._material._addReference(1);
    }
    get material() {
        return this._material;
    }
    set mesh(value) {
        if (this._mesh == value)
            return;
        this._mesh = value;
        this._meshRender._onMeshChange(this._mesh);
        this._renderElemnts = this._meshRender._renderElements;
        this._renderElemnts.forEach(element => {
            element.material = this._material;
            element.setTransform(this._transform);
            element.renderSubShader = this._material._shader.getSubShaderAt(this._subShaderIndex);
            element._subShaderIndex = this._subShaderIndex;
        });
    }
    getRenderCMD() {
        return this._drawRenderCMDDData;
    }
    run() {
        this._meshRender.sharedMaterial = this.material;
        this._meshRender._baseRenderNode.transform = this._transform;
        this._meshRender._baseRenderNode.ismoved.setValue(Stat.loopCount, LayaGL.renderEngine._framePassCount);
        this._meshRender.renderUpdate(RenderContext3D._instance);
        this._meshRender.probReflection = RenderContext3D._instance.scene.sceneReflectionProb;
        this._drawRenderCMDDData.destSubShader = this.material.shader.getSubShaderAt(this._subShaderIndex);
        this._drawRenderCMDDData.destShaderData = this.material.shaderData;
        this._drawRenderCMDDData.node = this._meshRender._baseRenderNode;
    }
    recover() {
        DrawMeshCMD._pool.recover(this);
        super.recover();
        this._material && (this.material = null);
        this._mesh && (this.mesh = null);
    }
    destroy() {
        super.destroy();
        this._renderElemnts.forEach(element => {
            element.destroy();
        });
        this._material && this._material._removeReference(1);
        this._material = null;
        this._renderElemnts = null;
        this._transform = null;
        this._material = null;
        this._matrix = null;
    }
}
DrawMeshCMD._pool = Pool.createPool(DrawMeshCMD);
